import styled from '@emotion/styled';
import { PlayerButton } from '@player/components/PlayerButton';
export const GotItButton = styled(PlayerButton) `
  width: 200px;
`;
export const EmailEmbedSuccessModalWrapper = styled.div `
  position: relative;
  background: var(--player-modal-background, var(--gray3));
  color: var(--player-modal-font-color);
  padding: 22px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 12px;
`;
